// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ISendCardSmsRequestModel {
    static getAttributeTypeMap() {
        return ISendCardSmsRequestModel.attributeTypeMap;
    }
}
ISendCardSmsRequestModel.discriminator = undefined;
ISendCardSmsRequestModel.additionalProperties = false;
ISendCardSmsRequestModel.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
];
//# sourceMappingURL=iSendCardSmsRequestModel.js.map